//Add Suspense and loader if need redirect
import { Suspense } from "react"

/* import TagManager from "react-gtm-module" */
import { HelmetProvider } from "react-helmet-async"

import AppRouter from "./AppRouter"
import CenteredFallback from "./components/CenteredFallback/CenteredFallback"
import Loader from "./components/Loader/Loader"
import { ContextWrapper } from "./context/AppContext"

/* const tagManagerArgs = {
  gtmId: "GTM-PPS2HW",
} */

//TagManager.initialize(tagManagerArgs)

const App = () => {
  return (
    <Suspense
      fallback={
        <CenteredFallback>
          <Loader />
        </CenteredFallback>
      }
    >
      <HelmetProvider>
        <ContextWrapper>
          <AppRouter />
        </ContextWrapper>
      </HelmetProvider>
    </Suspense>
  )
}

export default App
